import React, { createContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import commonApi from '../utils/api';

export const CommonContext = createContext();

const decryptData = (encryptedData, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

const secretKey = 'user-login-key';
export const CommonContextProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        const storedUserData = localStorage.getItem('userInfo');
        if (storedUserData) {
            try {
                return decryptData(storedUserData, secretKey);
            } catch (e) {
                console.error("Error decrypting user data", e);
                return null;
            }
        }
        return null;
    });
    const [userPermission, setUserPermission] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [modalAlert, setModalAlert] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [severity, setSeverity] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [courierList, setCourierList] = useState([]);
    const [merchant, setMerchant] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [walletAmount, setWalletAmount] = useState(null);
    const [merchantCourier, setMerchantCourier] = useState([]);
    const [globalSearch, setGlobalSearch] = useState({
        type: 'B2C',
        value: '',
        searchTrigger: 0
    });
    const [dropUsers, setDropUsers] = useState([]);
    const [userTlist, setUserTlist] = useState([]);
    const [permission, setPermission] = useState([]);
    const [orderEvents, setOrderEvents] = useState(() => {
        const orderEventsData = localStorage.getItem('ordersEvent');
        return orderEventsData ? JSON.parse(orderEventsData) : null;
    });
    const [userProductType, setUserProductType] = useState(() => {
        const productTypeData = localStorage.getItem('productType');
        return productTypeData ? JSON.parse(productTypeData) : null;
    });
    const [deliveryBoy, setDeliveryBoy] = useState([]);
    const [isDetails, setIsDetails] = useState(false);
    const [rowData, setRowData] = useState(null);
    const [merchantDetails, setMerchantDetails] = useState([]);
    const [mCourierLoading, setMCourierLoading] = useState(false);
    const ivrOptions = [
        { id: 1, label: "RECEIVED", subOptions: [{ id: 11, label: "ON CALL" }, { id: 12, label: "MAIL" }] },
        { id: 2, label: "NOT RECEIVED", subOptions: [] },
        { id: 3, label: "LANGUAGE ISSUE", subOptions: [] },
        { id: 4, label: "CALL ME LATER", subOptions: [{ id: 41, label: "FOLLOW DATE" }] },
        { id: 5, label: "WRONG NUMBER", subOptions: [] },
        { id: 6, label: "DAMAGE/SHORT RECEIVED", subOptions: [] },
        {
            id: 7,
            label: "NOT CONTACTABLE",
            subOptions: [
                { id: 71, label: "NOT ANSWERING" },
                { id: 72, label: "INVALID NUMBER" },
                { id: 73, label: "CALL DISCONNECT BY CUSTOMER" },
                { id: 74, label: "CALL NOT CONNECT" },
                { id: 75, label: "NUMBER BUSY" },
            ],
        },
    ];

    const getStatusLabel = (status) => {
        const foundOption = ivrOptions.find((option) => option.id === status);
        return foundOption ? foundOption.label : "Unknown Status";
    };


    const getOrderStatus = (eventCode) => {
        const event = orderEvents?.find(e => e?.event_code === eventCode?.toString());
        return event ? event.event_name : 'Unknown';
    };
    // console.log('orderEvents', orderEvents);
    // map event codes to colors
    const getOrderStatusColor = (eventCode) => {
        switch (eventCode?.toString()) {
            // Booking & Pickup
            case "1": // Booking received
            case "20": // Booking Pending
            case "2":  // Pickup Schedule
                return "info";

            // In Progress
            case "3":  // Picked
            case "4":  // At Branch/Warehouse
            case "5":  // In Transit
            case "7":  // Out for Delivery
            case "25": // Received at Noida Branch
            case "28": // Received at Kolkata Branch
            case "29": // Received at Lucknow Branch
            case "34": // Gurgaon Branch
                return "warning";

            // Success
            case "8":  // Delivered
            case "12": // RTO Delivered to Merchant
            case "11": // RTO Delivered to Branch/Warehouse
            case "19": // Partially Delivered
                return "success";

            // Failed / Cancelled / Lost
            case "9":  // Delivery Failed
            case "13": // Forward LOST
            case "14": // RTO LOST
            case "15": // Forward Damage
            case "16": // RTO Damage
            case "21": // Booking Failed
            case "23": // Cancelled by Merchant
            case "24": // Not Shipped
            case "26": // Wrong Book
            case "33": // Auto Cancelled
                return "error";

            // RTO & Special cases
            case "10": // RTO INTRANSIT
            case "18": // RTO Pending
            case "17": // Shipment Heldup
            case "27": // Shipment left for next facility Lucknow
            case "30": // Shipment left for next facility Noida
            case "32": // Shipment left for next facility
                return "secondary";

            default:
                return "default";
        }
    };

    useEffect(() => {
        const orderEventsData = localStorage.getItem('ordersEvent');
        const productTypeData = localStorage.getItem('productType');
        if (orderEventsData) {
            setOrderEvents(JSON.parse(orderEventsData))
        }
        if (productTypeData) {
            setUserProductType(JSON.parse(productTypeData));
        }
    }, [user]);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        setMerchantCourier([]);
    }, [location]);
    const detailsToggleDrawer = () => {
        setIsDetails(!isDetails);
        setOpenAlert(false);
        setAlertMessage('');
        setSeverity('');
        if (user?.user_type === "Merchant") {
            setRowData(user);
        } else {
            setRowData(null);
        }
    };
    const onCloseAlert = () => {
        setOpenAlert(false);
        setModalAlert(false);
        setAlertMessage('');
        setSeverity('');
        setModalAlert(false);
    };
    useEffect(() => {
        setAlertMessage('');
        setSeverity('');
        setOpenAlert(false);
        setIsLoading(false);
        setModalAlert(false);
    }, [location]);
    const hasQueryParams = location.search.trim() !== "";
    useEffect(() => {
        const storedUser = localStorage.getItem('userInfo');
        if (!storedUser && location.pathname === '/admin') {
            navigate('/admin');
        } else if (!storedUser && !hasQueryParams && !['/login', '/signup', '/forgot-password'].includes(location.pathname)) {
            navigate('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);
    const allPermissions = async (id) => {
        setIsLoading(true);
        try {
            const response = await commonApi.post('users/permissions', { admin_id: id });
            if (response.data.s === 1) {
                setPermission(response.data.data);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.error('Unauthorized access - Redirecting to login');
            } else {
                console.error('Failed to fetch listData:', error);
            }
        } finally {
            setIsLoading(false);
        }
    };
    const onAllUserDrop = (userType) => {
        // console.log('userType', userType);
        let postReq = {};
        if (user?.user_type !== "Merchant") {
            postReq.admin_id = user?.id
        }
        // console.log('userType1', userType);
        if (userType) {
            postReq.user_type = userType;
        }
        // console.log('userType12', userType);
        // setFirstLoading(false);
        commonApi.post('/users/list', postReq)
            .then((response) => {
                // setFirstLoading(true);
                if (response?.data?.data) {
                    setDropUsers(response?.data?.data);
                }
            })
            .catch((error) => {
                // setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const commonUserType = () => {
        commonApi.post('/users/UserTypelistForDropDown')
            .then((response) => {
                if (response?.data) {
                    setUserTlist(response?.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const commonMerchant = (type) => {
        let postReq = { service_type: type ?? '1' };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        commonApi.post('merchant/listForDropDown', postReq)
            .then((response) => {
                if (response?.data?.data) {
                    setMerchant(response?.data?.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const rechargeAmount = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        commonApi.post('merchant-recharge/view', postReq)
            .then((response) => {
                if (response?.data?.s === 1) {
                    setWalletAmount(response?.data?.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const courierData = (type) => {
        let postReq = { service_type: type ?? '' };
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        setCourierList([])
        setIsLoading(true);
        commonApi.post('courier/listForDropDown', postReq)
            .then((response) => {
                setIsLoading(false);
                if (response?.data?.s === 1) {
                    setCourierList(response?.data?.data);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error('Error fetching data:', error);
            });
    }
    const onMerchantCourier = (id, service) => {
        setMCourierLoading(false);
        const postReq = {}
        if (id) {
            postReq.merchant_id = id
        } else if (location?.state) {
            postReq.merchant_id = location?.state?.id
        } else {
            postReq.merchant_id = user?.id
        }
        if (service !== undefined && service !== null) {
            postReq.service_type = service
        } else {
            postReq.service_type = '1'
        }
        setMerchantCourier([]);
        commonApi.post('/merchant/get-my-couriers', postReq)
            .then((response) => {
                setMCourierLoading(true);
                if (response?.data?.data) {
                    setMerchantCourier(response?.data?.data);
                }
            })
            .catch((error) => {
                setMCourierLoading(true);
                console.error('Error fetching data:', error);
            });
    };
    const onDeliveryBoy = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { admin_id: 1 }
        }
        commonApi.post('/users/DeliveryBoylistForDropDown', postReq)
            .then((response) => {
                if (response?.data?.s === 1) {
                    setDeliveryBoy(response?.data?.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const onBranchDrop = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq.merchant_id = user?.id
        } else {
            postReq.admin_id = user?.id
        }
        commonApi.post('/branch/listForDropDown', postReq)
            .then((response) => {
                if (response?.data?.s === 1) {
                    setBranchList(response?.data?.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    const onMerchantDetails = (id) => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { merchant_id: id }
        }
        setMerchantDetails([]);
        commonApi.post('merchant/merchant-details', postReq)
            .then((response) => {
                if (response?.data?.data) {
                    setMerchantDetails(response?.data?.data);
                }
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };
    useEffect(() => {
        if (user) {
            courierData();
            if (user?.user_type === 'Merchant') {
                rechargeAmount();
            } else {
                commonMerchant();
                onBranchDrop();
                commonUserType();
                allPermissions(user?.id);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    useEffect(() => {
        if (user && user?.user_type !== 'Merchant') {
            if (location.pathname === '/merchants/registered') {
                onAllUserDrop(8);
            } else {
                onAllUserDrop();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user, location.pathname]);
    const contextValue = {
        mCourierLoading,
        merchantDetails,
        onMerchantDetails,
        rowData,
        setRowData,
        isDetails,
        setIsDetails,
        detailsToggleDrawer,
        walletAmount,
        deliveryBoy,
        onDeliveryBoy,
        permission,
        userTlist,
        dropUsers,
        onAllUserDrop,
        commonMerchant,
        courierData,
        globalSearch,
        setGlobalSearch,
        merchantCourier,
        onMerchantCourier,
        getOrderStatus,
        getOrderStatusColor,
        orderEvents,
        userProductType,
        merchant,
        courierList,
        user,
        setUser,
        userPermission,
        setUserPermission,
        isLoading,
        setIsLoading,
        modalAlert,
        setModalAlert,
        openAlert,
        setOpenAlert,
        severity,
        setSeverity,
        alertMessage,
        setAlertMessage,
        onCloseAlert,
        getStatusLabel,
        branchList,
        onBranchDrop,
    };
    return (
        <CommonContext.Provider value={contextValue}>
            {children}
        </CommonContext.Provider>
    );
};

